import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { adminService } from '../../../services/adminService';

export default function UserManagement() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUserStats();
  }, []);

  const loadUserStats = async () => {
    try {
      const data = await adminService?.getUserStats();
      setStats(data);
    } catch (err) {
      console.error('Failed to load user stats:', err);
    } finally {
      setLoading(false);
    }
  };

  const userCategories = [
    { label: 'العملاء', count: stats?.customers || 0, icon: 'Users', color: 'blue' },
    { label: 'المصورون', count: stats?.photographers || 0, icon: 'Camera', color: 'purple' },
    { label: 'المشرفون', count: stats?.admins || 0, icon: 'Shield', color: 'emerald' },
  ];

  const colorMap = {
    blue: { bg: 'bg-blue-50', text: 'text-blue-800', icon: '#3b82f6' },
    purple: { bg: 'bg-blue-50', text: 'text-blue-800', icon: '#a855f7' },
    emerald: { bg: 'bg-emerald-50', text: 'text-emerald-800', icon: '#10b981' },
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
          إدارة المستخدمين
        </h2>
        <button 
          onClick={() => window.location.href = '/admin?tab=photographers'}
          className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors flex items-center gap-2 cursor-pointer"
        >
          <Icon name="UserPlus" size={18} color="white" />
          <span className="text-sm font-medium" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>إضافة مستخدم</span>
        </button>
      </div>
      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
        </div>
      ) : (
        <div className="space-y-4">
          {userCategories?.map((category, index) => {
            const colors = colorMap?.[category?.color];
            return (
              <div key={index} className={`${colors?.bg} rounded-lg p-4 flex items-center justify-between`}>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm">
                    <Icon name={category?.icon} size={24} color={colors?.icon} />
                  </div>
                  <div>
                    <p className={`text-sm font-medium ${colors?.text}`} style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
                      {category?.label}
                    </p>
                    <p className={`text-2xl font-bold ${colors?.text}`}>{category?.count?.toLocaleString('ar-SA')}</p>
                  </div>
                </div>
                <button 
                  onClick={() => {
                    if (category.label === 'المصورون') {
                      window.location.href = '/admin?tab=photographers';
                    } else if (category.label === 'العملاء') {
                      window.location.href = '/admin?tab=customers';
                    } else if (category.label === 'المشرفون') {
                      window.location.href = '/admin?tab=overview';
                    }
                  }}
                  className="px-3 py-1 bg-white rounded-lg hover:shadow-md transition-shadow cursor-pointer"
                >
                  <Icon name="ChevronLeft" size={20} color={colors?.icon} />
                </button>
              </div>
            );
          })}

          <div className="pt-4 border-t border-slate-200">
            <div className="grid grid-cols-2 gap-4">
              <button className="px-4 py-3 bg-slate-50 hover:bg-slate-100 rounded-lg transition-colors flex items-center justify-center gap-2">
                <Icon name="Download" size={18} color="#64748b" />
                <span className="text-sm font-medium text-slate-700" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>تصدير البيانات</span>
              </button>
              <button className="px-4 py-3 bg-slate-50 hover:bg-slate-100 rounded-lg transition-colors flex items-center justify-center gap-2">
                <Icon name="Filter" size={18} color="#64748b" />
                <span className="text-sm font-medium text-slate-700" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>تصفية المستخدمين</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}